import { useGetDashboardSummaryQuery } from '../../../services/MedNecService';

export const useMedNecDashboardData = (facility: string) => {
  const { data, isLoading, error } = useGetDashboardSummaryQuery(facility || undefined, {
    skip: !facility,
  });

  return {
    statusCounts: data?.statusCounts || {} as Record<string, number>,
    totalCount: data?.total || 0,
    isLoading,
    hasError: !!error,
  };
};
